module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component-subscription-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns medium-6"
  }, [_c('driver', {
    attrs: {
      "type": 'driver-card',
      "item": _vm.item.client.main_driver
    }
  })], 1)]), _c('div', {
    staticClass: "row columns"
  }, [_c('tab-headers', {
    attrs: {
      "tabs": _vm.tabHeaders,
      "id": 'subscription-details',
      "activeIndex": 0
    }
  }, [_c('tab-content', {
    attrs: {
      "headerName": 'Subscription',
      "active": true
    }
  }, [_c('subscription', {
    attrs: {
      "item": _vm.item,
      "type": 'card-header-include'
    }
  }), _c('subscription', {
    attrs: {
      "item": _vm.item,
      "type": 'subscription-action-details'
    }
  })], 1), (_vm.$acl('index-log')) ? _c('tab-content', {
    attrs: {
      "headerName": 'Logs'
    }
  }, [_c('base-list', {
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader
    }
  })], 1) : _vm._e()], 1)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ee27e62!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/controllers/Subscription.vue
// module id = 2290
// module chunks = 1